<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e2617"><a href="#/Wise_9781401685553_epub_c6_r1#d6e1" id="d7e1"><i>Pennsylvania Dutch <br/> Glossary</i></a></p>
<p class="pub" id="d7e2697"><i>aamen</i>—amen</p>
<p class="pub" id="d7e2747"><i>ach</i>—oh</p>
<p class="pub" id="d7e2797"><i>aenti</i>—aunt</p>
<p class="pub" id="d7e2847"><i>bruder—</i>brother</p>
<p class="pub" id="d7e2907"><i>The Budget</i>—a weekly newspaper serving Amish and Mennonite communities everywhere</p>
<p class="pub" id="d7e2987"><i>daadi</i>—grandfather</p>
<p class="pub" id="d7e3037"><i>daed</i>—dad</p>
<p class="pub" id="d7e3097"><i>danki</i>—thanks</p>
<p class="pub" id="d7e3147"><i>dochder</i>—daughter</p>
<p class="pub" id="d7e3197"><i>dumm</i>—dumb</p>
<p class="pub" id="d7e3247"><i>dummkopp</i>—dummy</p>
<p class="pub" id="d7e3307"><i>Englisch</i>—a non-Amish person</p>
<p class="pub" id="d7e3357"><i>fraa</i>—wife</p>
<p class="pub" id="d7e3407"><i>gut</i>—good</p>
<p class="pub" id="d7e3467"><i>guder mariye</i>—good morning</p>
<p class="pub" id="d7e3517"><i>hatt</i>—hard</p>
<p class="pub" id="d7e3567"><i>haus</i>—house</p>
<p class="pub" id="d7e3617"><i>kapp</i>—prayer covering or cap</p>
<p class="pub" id="d7e3728"><i>kinner</i>—children or grandchildren</p>
<p class="pub" id="d7e3778"><i>kumme esse</i>—come eat</p>
<p class="pub" id="d7e3828"><i>lieb</i>—love</p>
<p class="pub" id="d7e3878"><i>maedel</i>—girl</p>
<p class="pub" id="d7e3938"><i>mamm</i>—mom</p>
<p class="pub" id="d7e3988"><i>mammi</i>—grandmother</p>
<p class="pub" id="d7e4038"><i>mei</i>—my</p>
<p class="pub" id="d7e4088"><i>mudder</i>—mother</p>
<p class="pub" id="d7e4148"><i>nee</i>—no</p>
<p class="pub" id="d7e4198"><i>onkel</i>—uncle</p>
<p class="pub" id="d7e4248"><i>Ordnung</i>—the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.</p>
<p class="pub" id="d7e4418">Pennsylvania <i>Deitsch</i>—Pennsylvania German, the language most commonly used by the Amish</p>
<p class="pub" id="d7e4528"><i>rumschpringe</i>—running-around period when a teenager turns sixteen years old</p>
<p class="pub" id="d7e4608"><i>schee beh</i>—nice legs</p>
<p class="pub" id="d7e4668"><i>sohn</i>—son</p>
<p class="pub" id="d7e4718"><i>Wie bischt?</i>—How are you?</p>
<p class="pub" id="d7e4788"><i>ya</i>—yes</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wise_9781401685553_epub_c6.5_r1.vue?96c54dfc